import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PhxBaseDetailSaveButtonComponent } from "../../../../shared/components/phx-base-detail-save-button/phx-base-detail-save-button.component";
import { BlockableDiv } from "../../../../shared/controls/blockable-div/blockable-div.component";
import { WidgetSetUserToMenuComponent } from "./widget-set-user-to-menu.component";

@Component({
  selector: 'app-formly-set-user-to-menu',
  imports: [
    BlockableDiv,
    WidgetSetUserToMenuComponent,
    PhxBaseDetailSaveButtonComponent,
    TranslatePipe
  ],
  template: `
    <blockable-div [blocked]="!model?.id" [blockUi]="blockUi">
      @defer (when model?.id) {
          <app-widget-set-user-to-menu
            [selectedMenu]="model"
            [showMenuDropdown]="false"
          />
        }
    </blockable-div>

    <ng-template #blockUi>
        <app-phx-base-detail-save-button
          [baseDetailComponent]="formState.detailComponent"
          [saveButtonLabel]="'common.save' | translate"
        />
    </ng-template>
  `,
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlySetUserToMenuComponent extends FieldType<FieldTypeConfig> { }
